module.exports = __webpack_public_path__ + "img/Font 01.717e12b6.jpg";